<template>
  <div>
    <input
      type="radio"
      id="community"
      v-model="selectedOption"

      value="community"
    />
    <label for="community" style="margin-right: 10px">小区</label>
    <input
      type="radio"
      id="certAddress"
      v-model="selectedOption"
      value="certAddress"
    />
    <label for="certAddress">地址</label>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [
        { value: 'community', label: '选项 1' },
      ],
    },
    initialValue: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      selectedOption: this.initialValue
    };
  },
  watch: {
    selectedOption(newValue) {
      this.$emit('input', newValue);
    }
  }
};
</script>

<style scoped>
/* 隐藏原生的单选框 */
input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 19px;
  height: 19px;
  border-radius: 4px;
  border: 2px solid #AAAAAA;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}

/* 选中状态下显示内部蓝色小正方形 */
input[type="radio"]:checked::after {
  content: "";
  display: block;
  width: 11px;
  height: 11px;
  background: #0459FC;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>